export default __webpack_public_path__ + "static/media/projectSettingsColoredIcon.529f4a56.svg";